import * as JsonSchema from '../../utils/json-schema'

export type T = WatchProcedure

type WatchProcedure = {
  id: string
  name: string,
  status: 'Open'|'Closed',
  description: string,
  schedule: Schedule,
  isCritical: boolean,
  currentWatchPeriod?:string
}

export type Schedule =
  | DailySchedule
  | WeeklySchedule

type DailySchedule = {
  frequency: 'Daily',
  ianaTimezone: string,
  hour: number
}

type WeeklySchedule = {
  frequency: 'Weekly',
  ianaTimezone: string,
  dayOfWeek: number
  hour: number
}

const DAILY_SCHEDULE_SCHEMA: JsonSchema.T<DailySchedule> = {
  type      : 'object',
  required  : [ 'frequency', 'ianaTimezone', 'hour' ],
  properties: {
    frequency   : { type: 'string', 'const': 'Daily' },
    ianaTimezone: { type: 'string' },
    hour        : { type: 'number' },
  }
}

const WEEKLY_SCHEDULE_SCHEMA: JsonSchema.T<WeeklySchedule> = {
  type      : 'object',
  required  : [ 'frequency', 'ianaTimezone', 'dayOfWeek', 'hour' ],
  properties: {
    frequency   : { type: 'string', 'const': 'Weekly' },
    ianaTimezone: { type: 'string' },
    dayOfWeek   : { type: 'number' },
    hour        : { type: 'number' },
  }
}

const SCHEDULE_SCHEMA: JsonSchema.T<Schedule> = {
  oneOf: [
    DAILY_SCHEDULE_SCHEMA,
    WEEKLY_SCHEDULE_SCHEMA
  ]
}

const WATCH_PROCEDURE_SCHEMA: JsonSchema.T<WatchProcedure> = {
  type      : 'object',
  required  : [ 'id', 'name', 'status', 'description', 'schedule', 'isCritical' ],
  properties: {
    id                : { type: 'string' },
    name              : { type: 'string' },
    status            : { type: 'string', 'enum': [ 'Open', 'Closed' ] },
    description       : { type: 'string' },
    schedule          : SCHEDULE_SCHEMA,
    isCritical        : { type: 'boolean' },
    currentWatchPeriod: { type: 'string', nullable: true },
  }
}

const WATCH_PROCEDURES_API_RESPONSE_SCHEMA: JsonSchema.T<WatchProcedure[]> = {
  type : 'array',
  items: WATCH_PROCEDURE_SCHEMA
}

export const parse = JsonSchema.parserForCollection(WATCH_PROCEDURES_API_RESPONSE_SCHEMA, 'watch procedures api responses')